import React from "react";

const ID_CATEGORIA_ORTODONTIA = "6817794ea65ef747fc747327";

function ObservacoesOrtodontia({ serviceList }) {
  const temOrtodontia = (serviceList || []).some((el) => {
    const categoria = el.tratamento?.categoria;
    return (categoria?._id || categoria) === ID_CATEGORIA_ORTODONTIA;
  });

  if (!temOrtodontia) {
    return <></>;
  }

  return (
    <div className="orcamento__observacoesOrto__container">
      <strong>Observações Importantes:</strong>
      <ol className="orcamento__observacoesOrto__lista">
        <li>
          O valor referente às fotos e aos moldes deve ser pago antes da
          colocação do aparelho.
        </li>
        <li>
          O valor do aparelho será dividido em 9 (nove) parcelas de{" "}
          <span className="orcamento__observacoesOrto__destaque">€170</span>{" "}
          cada.
        </li>
        <li>
          O valor do aparelho de contenção será pago no dia da remoção do
          aparelho ortodôntico.
        </li>
        <li>
          Caso seja necessária a realização da cirurgia de freio, o pagamento
          deverá ser feito no mesmo dia da colocação do aparelho, juntamente com
          a primeira parcela.
        </li>
        <li>
          A desistência ou abandono do tratamento por iniciativa do paciente não
          o isenta do pagamento do valor total do tratamento previamente
          acordado, independentemente da fase em que o mesmo se encontre.
        </li>
        <li>
          Qualquer consulta adicional às consultas de manutenção, destinada à
          substituição, reparação ou colagem de componentes do aparelho
          ortodôntico, poderá ser cobrada separadamente, de acordo com a tabela
          de preços em vigor.
        </li>
        <li>
          O presente orçamento faz parte integrante do Consentimento Informado e
          Contrato de Prestação de Serviços de Ortodontia, devendo ambos os
          documentos ser lidos e assinados pelo paciente antes do início do
          tratamento.
        </li>
      </ol>
    </div>
  );
}

export default ObservacoesOrtodontia;
